import script from "./hallbox.vue?vue&type=script&setup=true&lang=js"
export * from "./hallbox.vue?vue&type=script&setup=true&lang=js"

import "./hallbox.vue?vue&type=style&index=0&id=5f6b97b8&scoped=true&lang=css"

import exportComponent from "C:\\vue2025\\cmsmap2023\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f6b97b8"]])

export default __exports__